import React, { createContext, useState } from "react";

const MyContext = createContext();

export const MyContextProvider = ({ children }) => {
  const [newCustomAttributeDetails, setNewCustomAttributeDetails] = useState({
    name: "",
    key: "",
    format: "",
  });

  // const baseUrl= 'https://payin.shreedevs.com';
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? "https://uat.anlook.com" // Development API
      : "https://api.anlook.com"; // Production API
  const baseUrl2 =
    process.env.NODE_ENV === "development"
      ? "https://openapi.shreedevs.com"
      : "https://openApi.anlook.com";
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
    },
  };
  const config2 = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
   
    },
  };

  return (
    <MyContext.Provider
      value={{
        setNewCustomAttributeDetails,
        newCustomAttributeDetails,
        baseUrl,
        baseUrl2,
        config,
        config2,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default MyContext;
